import { render } from "./TotalField.vue?vue&type=template&id=6c143053"
import script from "./TotalField.vue?vue&type=script&lang=js"
export * from "./TotalField.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__